import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as FlatModels from "@medsurf/flat-models";

@Component({
    selector: 'medsurf-slide-edit-free-form-shape',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './free-form-shape.component.html',
    styleUrls: ['./free-form-shape.component.scss'],
    standalone: false
})
export class FreeFormShapeComponent {
  readonly FlatModels = FlatModels;
}
